export function DashboardWidget({
  label,
  value,
  accent = 'default',
}: {
  label: string;
  value: string | number;
  accent?: 'default' | 'green' | 'gold';
}) {
  const accentClass = {
    default: 'text-seal-blue',
    green: 'text-ledger-green',
    gold: 'text-gold',
  }[accent];

  return (
    <div className="rounded-lg border border-line bg-white p-5">
      <p className="text-sm text-ink/50">{label}</p>
      <p className={`mt-1 font-display text-3xl font-bold ${accentClass}`}>{value}</p>
    </div>
  );
}
